import { render, staticRenderFns } from "./PricingEditBox.vue?vue&type=template&id=6c7d0ffe&scoped=true&"
import script from "./PricingEditBox.vue?vue&type=script&lang=js&"
export * from "./PricingEditBox.vue?vue&type=script&lang=js&"
import style0 from "./PricingEditBox.vue?vue&type=style&index=0&id=6c7d0ffe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7d0ffe",
  null
  
)

export default component.exports